"use client"

import { MAP_EMBED_URL } from "@/constants/map"
import { cn } from "@/lib/utils"
import { ComponentConfig } from "@measured/puck"

export type MapDisplayProps = {
  mapHeight?: string
  className?: string
}

export const RenderConfig: ComponentConfig<MapDisplayProps> = {
  render: ({ mapHeight = "450", className }) => {
    const mapEmbedUrl = MAP_EMBED_URL
    return (
      <div className={cn("w-full", className)}>
        <div className="relative">
          <iframe
            src={mapEmbedUrl}
            width="100%"
            height={mapHeight}
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="w-full rounded-3xl shadow-lg"
          />
        </div>
      </div>
    )
  },
}
